import './bml-cooperation.scss';

const TEMPLATE = `
<section class="cooperation-container fade-up" id="cooperation">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-6">
                <p class="section-label" data-animate-child>Партнерство з Bogomolets Medical Laboratories</p>
            </div>
            <div class="col-lg-6 col-md-6">
                <h3 data-animate-child data-delay="200">Індивідуальна співпраця для медичних партнерів</h3>
                <p data-animate-child data-delay="400">
                    У BML ми створюємо умови співпраці, які допомагають лікарям і клінікам працювати ефективніше.
                    Гнучкі формати та персоналізовані тарифи роблять партнерство з нами не лише зручним, а й
                    вигідним. Ми підлаштовуємося під ваші потреби, щоб діагностика завжди була швидкою, прозорою та
                    надійною.
                </p>
            </div>
        </div>

        <div class="partnership-benefits" data-animate-child data-delay="600">
            <div class="partnership-benefit-card">
                <h5>Гнучкі формати співпраці</h5>
                <p>Модель взаємодії адаптується до потреб вашого медичного закладу або практики.</p>
            </div>
            <div class="partnership-benefit-card">
                <h5>Індивідуальні комерційні умови</h5>
                <p>Персоналізовані умови співпраці залежно від формату, обсягів і потреб партнера.</p>
            </div>
            <div class="partnership-benefit-card">
                <h5>Персональний супровід</h5>
                <p>Оперативна комунікація та відповідальний координатор взаємодії.</p>
            </div>
            <div class="partnership-benefit-card">
                <h5>Експертна клінічна підтримка</h5>
                <p>Second opinion, консультації, клініко-морфологічні кореляції, підтримка складних випадків.</p>
            </div>
            <div class="partnership-benefit-card">
                <h5>Пріоритетний сервіс</h5>
                <p>Оперативна обробка термінових кейсів та швидке реагування.</p>
            </div>
            <div class="partnership-benefit-card">
                <h5>Надійний контроль якості</h5>
                <p>Міжнародні стандарти, внутрішній контроль, міжлабораторна верифікація.</p>
            </div>
        </div>

    </div>
</section>
`;

class BmlCooperation extends HTMLElement {
    connectedCallback() {
        if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE;
    }
}

customElements.define('bml-cooperation', BmlCooperation);
